<template>
  <div
		class="t-tr"
		:style="{
			background: zebraStripe && (tableIndex % 2 === 0) ? zebraColor : '#ffffff'
		}"
	>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String
		},
		tableIndex: {
			type: Number,
      default: 0
		}
  },
  data() {
    return {
      // 斑马纹颜色
      zebraColor: "#f8f8f8",
      // 是否开启斑马纹
      zebraStripe: false
    };
	},
	inject: ["table"],
  created() {
    this.zebraColor = this.table.zebraColor;
    this.zebraStripe = this.table.zebraStripe;
  },
  provide() {
    return {
      tr: this
    };
  },
  methods: {}
};
</script>

<style>
.t-tr {
  width: 100%;
  display: flex;
}

.t-tr t-th,
.t-tr t-td {
  display: flex;
  flex: 1;
}
</style>